import { createAction, props, union } from '@ngrx/store';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { ContainerMafGetQueryI } from 'src/app/api/container-maf-get/container-maf-get-query.int';
import { ContainerMafGetResponseI } from 'src/app/api/container-maf-get/container-maf-get-result.int';
/* eslint-disable max-len */

export const error = createAction('[MAF / Save] Error', props<{
  messageText: string;
  pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[MAF / Save] Reset', props<{
  pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[MAF / Save] Get', props<{
  query: ContainerMafGetQueryI;
  pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[MAF / Save] Received', props<{
  data: ContainerMafGetResponseI;
  pageType: SharedPageTypeEnum;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
